import { supabase } from '../supabase';
import { scopeMatchesParcel } from './contactResolve';

// resolveTbtRecipients — the SINGLE source of the INITIAL recipient population for a Tax Bill Transmittal.
// The picker is always editable on top of this; this only decides the pre-seed. Return shape is FIXED —
// { to: [{name,email}], cc: [{name,email}], source } — so the call site never changes.
//
// Recipients = contacts holding the 'tax_bill_transmittals' role AT this property whose re_pp_scope matches the
// BILL's parcel kinds (RE/PP from expected_bills). A bill is normally one kind (a BPP collector's bill → PP parcels
// → BPP/ALL managers, never the RE-only manager); a mixed-kind bill → the union. `source` feeds
// tax_bill_transmittals.recipient_source (audit trail).
export async function resolveTbtRecipients(propertyId, parcels) {
  if (!propertyId) return { to: [], cc: [], source: 'manual' };
  const kinds = [...new Set((parcels || []).map(p => p.kind).filter(Boolean))];
  const rePps = kinds.length ? kinds.map(k => k === 'PP' ? 'Personal Property' : 'Real Estate')
                             : ['Real Estate', 'Personal Property'];   // no kind info → don't over-narrow
  const { data, error } = await supabase.from('contact_properties')
    .select('re_pp_scope, contact:client_contacts(first_name,last_name,email)')
    .eq('property_id', propertyId).eq('role', 'tax_bill_transmittals');
  if (error || !data) return { to: [], cc: [], source: 'manual' };
  const to = data
    .filter(r => r.contact?.email && rePps.some(rp => scopeMatchesParcel(r.re_pp_scope, rp)))
    .map(r => ({ name: `${r.contact.first_name || ''} ${r.contact.last_name || ''}`.trim(), email: r.contact.email }));
  return { to, cc: [], source: to.length ? 'tbt_role' : 'manual' };
}
